import { useEffect, useState } from "react";

const KEY = "tickdoc_inventory_page_size";

/**
 * Inventory page size preference.
 *
 * Default: 50 on wide screens (Mac/PC), 25 elsewhere.
 * Persisted in localStorage; the user can override via the toolbar.
 */
export default function usePageSize() {
  const [pageSize, setPageSize] = useState(() => {
    if (typeof window === "undefined") return 25;
    const saved = Number(window.localStorage.getItem(KEY));
    if ([25, 50, 100].includes(saved)) return saved;
    return window.matchMedia("(min-width: 1280px)").matches ? 50 : 25;
  });

  useEffect(() => {
    try { window.localStorage.setItem(KEY, String(pageSize)); } catch { /* ignore */ }
  }, [pageSize]);

  return [pageSize, setPageSize];
}
